/*
Purpose:
- Configure pdf.js to load its worker from a public URL in builds that
  cannot use Vite-style `?url` imports (Vue CLI / webpack 4).

Returns:
- void: sets pdfjs-dist GlobalWorkerOptions.workerSrc as a side effect.
- Edge cases: does nothing if called in a non-browser environment.

Parameters:
- workerUrl (string): Public URL where `pdf.worker.mjs` is served.
  Example: '/pdfjs/pdf.worker.mjs'
*/
export function setupPdfJsWorker(workerUrl: string) {
  if (typeof window === 'undefined') return

  // NOTE(pspdfkit-to-bopus): Avoid importing `pdfjs-dist` in the webpack bundle.
  // pdfjs-dist v5 ships modern ESM that webpack 4 can't parse (optional chaining,
  // import.meta, etc). The actual PDF viewer (via @tato30/vue-pdf) is responsible
  // for loading pdfjs-dist; here we only provide the worker URL.
  const w = window as unknown as { pdfjsLib?: { GlobalWorkerOptions?: { workerSrc?: string } } }
  if (!w.pdfjsLib?.GlobalWorkerOptions) return
  w.pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl
}
